import React, { memo } from 'react'
import { Card } from './Card';

export const CardDragPreview = memo(({ src }) => {
    return (
        <div className="gm-card moving">
            <Card src={src} alt="preview only" />
        </div>
    )
});